import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '@env/environment';
import { TranslateService } from '@tolgee/ngx';
import { IClassification } from '@app/pages/cmms/interfaces/classification.interfaces';

export interface ISuggestedEntity {
	name: string;
	description: string;
	entity_type: string;
}

export interface ISearchSuggestion {
	url: string;
	title: string;
}

export interface IAiAssetAnalysisResponse {
	title: string;
	description: string;
	labels: string[];
	product_name: string;
	serial_number: string;
	product_year: number | null;
	installation_date: string;
	installation_cost: number;
	warranty_expired_date: string;
	condition_grade: number;
	condition_grade_description: string;
	building_component_table_code: string;
	data_sheet_url: string;
	technical_specifications: string;
	building_component_classification?: IClassification[];
	cost_of_repair: number;
	suggested_entities: ISuggestedEntity[];
	asset_suggestion: IAiAssetAnalysisResponse[];
	search_suggestions: ISearchSuggestion[];
}

@Injectable({ providedIn: 'root' })
export class ImageAnalysisService {
	private readonly httpClient = inject(HttpClient);
	private readonly endpoint = `${environment.cmmsHost}/api/ai_image_analysis`;
	private readonly translateService = inject(TranslateService);

	analyzeImages(fileUrls: string[], existingData: string = null): Observable<any> {
		const formData = new FormData();

		formData.append('file_urls', fileUrls.join(','));
		formData.append('language', this.translateService.tolgee.getLanguage());
		formData.append('files', '');

		if (existingData) {
			formData.append('existing_data', existingData);
		}

		return this.httpClient.post<any>(this.endpoint, formData);
	}
}
